import React, { useEffect } from 'react';
import classNames from 'classnames';
import SpinnerDots from '../spinner/dots';
import './styles.scss';

const Takeover = props => {

    useEffect(() => {
        if (props.isOpen) {
            window.document.body.classList.add('modal-open');
            window.document.body.style.overflow = 'hidden';
        } else {
            window.document.body.style.overflow = 'auto';
            window.document.body.classList.remove('modal-open');
        }
    }, [props.isOpen]);

    const isLoading = Boolean(props.isLoading);

    return (
        <div
            className={classNames({
                'takeover': true,
                'takeover--default': !(props.modifiers && props.modifiers['takeover--alt']),
                'takeover--is-open': props.isOpen,
                ...props.modifiers
            })}
            aria-busy={isLoading ? 'true' : undefined}
        >
            <button
                className="takeover__close"
                type="button"
                disabled={isLoading}
                onClick={() => props.toggleTakeover(!props.isOpen)}
            >
                <span>Stäng</span>
            </button>
            <div className="takeover__content">
                <div
                    className={classNames('takeover__inner', {
                        'takeover__inner--loading': isLoading
                    })}
                >
                    <div className="takeover__inner-fill">
                        {props.heading &&
                            <h1 className="takeover__heading">{props.heading}</h1>
                        }
                        {props.children}
                    </div>
                    {isLoading && (
                        <div className="takeover__loading-overlay" aria-hidden="true">
                            <SpinnerDots />
                        </div>
                    )}
                </div>
            </div>
            
            
        </div>
    );
};

export default Takeover;